import React from 'react';
import { Modify } from '../../types/common';
import placeholderImage from '../../assets/images/landscape-placeholder.svg';

type Props = Modify<React.ImgHTMLAttributes<HTMLImageElement>, {
  src: string | null | undefined;
}>;

export const Picture: React.FC<Props> = ({ src, ...props }) => {
  return (
    <img
      src={src ? `${process.env.REACT_APP_FILES_URL}/${src}` : placeholderImage}
      {...props}
    />
  );
};
